import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 88px 0;
  background: #f7f9fc;

  @media (max-width: 990px) {
    padding: 64px 0;
  }
  @media (max-width: 767px) {
    padding: 48px 0;
  }
`;

export const Intro = styled.div`
  max-width: 760px;
  margin: 0 auto 40px;
  text-align: center;

  > span {
    display: block;
    margin-bottom: 8px;
    color: #46679f;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.15em;
  }

  h2 {
    margin: 0 0 16px;
    color: #0f2137;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.03em;
  }

  p {
    margin: 0 0 12px;
    color: #5d646d;
    font-size: 17px;
    line-height: 1.75;
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 767px) {
    margin-bottom: 28px;
    h2 {
      font-size: 24px;
    }
    p {
      font-size: 16px;
    }
  }
`;

export const Shot = styled.figure`
  margin: 0 auto;
  max-width: 1110px;

  figcaption {
    margin-top: 12px;
    color: #5d646d;
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
  }
`;

/* Window frame for the not-yet-delivered screenshot: title bar with the three
   traffic-light dots, the placeholder below. */
export const Frame = styled.div`
  overflow: hidden;
  border: 1px solid #d5deec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 24px rgba(15, 33, 55, 0.12);

  .bar {
    display: flex;
    gap: 7px;
    padding: 12px 14px;
    background: #eef2f8;
    border-bottom: 1px solid #d5deec;
  }

  .bar i {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #c3cddd;
  }

  .body {
    padding: 16px;
  }
`;
